import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { User } from "@/database/userDatabaseService";

interface AuthState {
  user?: User;
}

// ** Slice
const initialState: AuthState = {};

export const authSlice = createSlice({
  name: "authentication",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User>) => {
      state.user = action.payload;
    },
  },
});

export const { setUser } = authSlice.actions;

export default authSlice.reducer;
